import triggerTracking from '@blueprint/tracking';
import { TRACKING_EVENT } from 'listing-details/constants';

export const trackBreadcrumbLinkClick = (
    action: string | null,
    value: number
) => {
    triggerTracking({
        event: TRACKING_EVENT,
        eventCategory: 'breadcrumb',
        eventAction: 'clickthrough',
        eventLabel: action || undefined,
        eventValue: value + 1
    });
};
